import React from "react";
import styled from "styled-components";
import { get } from "lodash";
import { getCellStyle } from "../utils";
import { scrollbarHeight } from "./Table";
import { useTranslation } from "react-i18next";

const RowTotal = ({ row, scrollBarSize, summaryTotal, width }) => {
  const { t } = useTranslation();
  if (!row) return null;
  return (
    <WrapperRowTotal
      id="row-total-group"
      scrollbarHeight={scrollbarHeight()}
      scrollBarWidth={scrollBarSize}
      className="tr"
      {...row.getRowProps()}
      style={{
        width: "100%",
      }}
    >
      <div
        style={{
          width: width + 50,
          height: "100%",
        }}
        className="tr header"
      >
        {row.cells.map((cell, index) => {
          const colId = cell.column.id;
          const colInfo = cell.column;
          const value = get(summaryTotal?.data, colId, "");
          const format = value?.format || colInfo?.format || "";

          return (
            <div
              className="td"
              style={{ ...getCellStyle(cell.getCellProps()) }}
              key={index}
            >
              {index === 0 ? (
                <CellTotal>{t("TOTAL_COLUMN")}</CellTotal>
              ) : (
                <CellTotalItem>
                  {value?.value} {format}
                </CellTotalItem>
              )}
            </div>
          );
        })}
      </div>
    </WrapperRowTotal>
  );
};

const WrapperRowTotal = styled.div`
  background: #f1f2f4 !important;
  height: 48px !important;
  min-height: 48px !important;
  z-index: 352;

  overflow-x: auto;
  overflow-y: hidden;

  position: absolute;
  left: 0;
  bottom: ${({ scrollbarHeight }) => scrollbarHeight}px;

  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  overflow-y: scroll;

  &::-webkit-scrollbar {
    display: none; /* for Chrome, Safari, and Opera */
  }

  .td {
    background: #f1f2f4 !important;
    border-bottom: 0 !important;

    font-weight: 700;
    font-size: 15px;

    &:hover {
      border-color: #edeae9 !important;
    }
  }
`;

const CellTotal = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-right: 30px;
`;

const CellTotalItem = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  font-weight: 500;
`;

export default RowTotal;
